export enum EUserGroups {
  Student = 1,
  Teacher = 2,
  Parent = 3,
  Admin = 4,
  Alumni = 5,
  Management = 6,
  Faculty = 7,
}

export const Homes: {
  [key: number]: string;
} = {
  1: '/dashboard/home',
  2: '/dashboard/default-home',
  3: '/dashboard/home',
  4: '/management/principal-dashboard',
  5: '/dashboard/home',
  6: '/management/principal-dashboard',
  7: '/dashboard/home',
  8: '/student-affairs/Dashboard ',
  9: '/dashboard/exam-controller-dashboard',
  10: '/dashboard/placement-dashboard',
  13: '/dashboard/transportation-controller-dashboard',

}

export enum ModuleModuleID {
  'StudentAffairs' = 1,
  'Academics' = 2,
  'Fees' = 3,
  'Accounts' = 4,
  'Payroll & Staff' = 5,
  'Library' = 6,
  'Adminstration' = 7,
  'AdmissionPortal' = 8,
  'ExamController' = 9,
  'TransportationController' = 13,
  'PlacementController' = 10
}
